import { createTheme, ThemeProvider as MThemeProvider } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { makeStyles } from "@mui/styles";
import React, { useContext, useState } from "react";
import { AppStyles, AppTheme } from "../values/themes";

const ThemeContext = React.createContext();

export const ThemeProvider = ({ children }) => {
  const LightTheme = createTheme(AppTheme.light);
  const DarkTheme = createTheme(AppTheme.dark);
  // const LightThemXXe = createTheme({
  //   components: {
  //     MuiMenu: {
  //       styleOverrides: {
  //         root: {
  //           boxShadow: "0 0 20px rgba(0,0,0, 0.15)",
  //         },
  //         paper: {
  //           boxShadow: "0 0 20px rgba(0,0,0, 0.15)",
  //         },
  //       },
  //     },
  //     MuiMenuItem: {
  //       styleOverrides: {
  //         selected: {
  //           fontSize: 15,
  //         },
  //       },
  //     },
  //   },
  // });
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [theme, setTheme] = useState(null);
  const UsedStyles = makeStyles(AppStyles.classes(theme || LightTheme));
  const classes = UsedStyles();

  React.useEffect(() => {
    setTheme(prefersDarkMode ? DarkTheme : LightTheme);
  }, [prefersDarkMode]);

  React.useEffect(() => {
    if (theme === null) {
      setTheme(
        localStorage.getItem("theme") === "dark" ? DarkTheme : LightTheme
      );
    } else {
      localStorage.setItem("theme", theme.palette.mode);
    }
  }, [theme]);

  return (
    <ThemeContext.Provider
      value={{
        theme: theme || LightTheme,
        setTheme,
        styles: {
          light: LightTheme,
          dark: DarkTheme,
          classes: classes,
        },
      }}
    >
      <MThemeProvider theme={theme || LightTheme}>{children}</MThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeProvider = () => {
  return useContext(ThemeContext);
};
